(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comprehensive-beneits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const flipCards = document.querySelectorAll('.flip-card');
    const isMobile = window.innerWidth <= 768;
    
    flipCards.forEach((card) => {
      const expandBtn = card.querySelector('.flip-card__expand-btn');
      const closeBtn = card.querySelector('.flip-card__close-btn');
      
      expandBtn?.addEventListener('click', function (e) {
        e.stopPropagation();
        if (isMobile) {
          document.querySelectorAll('.flip-card--flipped').forEach((flippedCard) => {
            if (flippedCard !== card) {
              flippedCard.classList.remove('flip-card--flipped');
            }
          });
        }
        card.classList.add('flip-card--flipped');
      });
      
      closeBtn?.addEventListener('click', function (e) {
        e.stopPropagation();
        card.classList.remove('flip-card--flipped');
      });
      
      if (!isMobile) {
        card.addEventListener('click', function (e) {
          if (card.classList.contains('flip-card--flipped') && 
              !e.target.closest('.flip-card__back') &&
              !e.target.closest('.flip-card__expand-btn') &&
              !e.target.closest('.flip-card__close-btn')) {
            card.classList.remove('flip-card--flipped');
          }
        });
      }
    });

    if (!isMobile) {
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.flip-card')) {
          document.querySelectorAll('.flip-card.flip-card--flipped').forEach((card) => {
            card.classList.remove('flip-card--flipped');
          });
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.flip-card.flip-card--flipped').forEach((card) => {
          card.classList.remove('flip-card--flipped');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-featured-blog"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.hm__featured__blog__slider');
  if (!slider) return;

  const track = slider.querySelector('.hm__featured__blog__track');
  const slides = slider.querySelectorAll('.hm__featured__blog__item');
  const prevBtn = slider.querySelector('.hm__slider__button--prev');
  const nextBtn = slider.querySelector('.hm__slider__button--next');

  let currentIndex = 0;
  let isDragging = false;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;

  function getSlidesPerView() {
    const width = window.innerWidth;
    if (width >= 1440) return 5;
    if (width >= 1024) return 4;
    if (width >= 768) return 3;
    if (width >= 480) return 2;
    return 1;
  }

  function updateSlider() {
    const slidesPerView = getSlidesPerView();
    const slideWidth = slides[0].offsetWidth + 20;
    
    const totalSlides = slides.length;
    const maxIndex = Math.max(0, totalSlides - slidesPerView);

    currentIndex = Math.min(currentIndex, maxIndex);
    currentIndex = Math.max(currentIndex, 0);

    // Calculate transform
    const translateValue = currentIndex * slideWidth;
    track.style.transform = `translateX(-${translateValue}px)`;

    updateButtonStates();
  }

  function updateButtonStates() {
    const slidesPerView = getSlidesPerView();
    const totalSlides = slides.length;
    const maxIndex = Math.max(0, totalSlides - slidesPerView);
    
    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex >= maxIndex;
  }

  // BUTTON CLICK
  prevBtn.addEventListener('click', function() {
    currentIndex = Math.max(currentIndex - 1, 0);
    updateSlider();
  });

  nextBtn.addEventListener('click', function() {
    const slidesPerView = getSlidesPerView();
    const totalSlides = slides.length;
    const maxIndex = Math.max(0, totalSlides - slidesPerView);
    currentIndex = Math.min(currentIndex + 1, maxIndex);
    updateSlider();
  });

  // DRAG & SWIPE
  track.addEventListener('mousedown', startDrag);
  track.addEventListener('touchstart', startDrag);

  track.addEventListener('mouseup', endDrag);
  track.addEventListener('mouseleave', endDrag);
  track.addEventListener('touchend', endDrag);

  track.addEventListener('mousemove', drag);
  track.addEventListener('touchmove', drag);

  function startDrag(e) {
    isDragging = true;
    startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
    prevTranslate = currentIndex * (slides[0].offsetWidth + 20);
    track.style.transition = 'none';
  }

  function drag(e) {
    if (!isDragging) return;
    e.preventDefault();
    const currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
    const walk = startX - currentX;
    currentTranslate = prevTranslate + walk;
    track.style.transform = `translateX(-${currentTranslate}px)`;
  }

  function endDrag(e) {
    if (!isDragging) return;
    isDragging = false;
    track.style.transition = 'transform 0.5s ease-in-out';

    const slideWidth = slides[0].offsetWidth + 20;
    const draggedSlides = Math.round(currentTranslate / slideWidth);
    const slidesPerView = getSlidesPerView();
    const totalSlides = slides.length;
    const maxIndex = Math.max(0, totalSlides - slidesPerView);

    // Snap to nearest slide
    currentIndex = Math.max(0, Math.min(draggedSlides, maxIndex));
    updateSlider();
  }

  window.addEventListener('resize', function() {
    currentIndex = 0;
    updateSlider();
  });

  // Prevent image drag
  slider.querySelectorAll('img').forEach(img => {
    img.addEventListener('dragstart', (e) => e.preventDefault());
  });

  updateSlider();
});

  } catch(e) { console.error(e); }
})();
})();
